/* global attachEvent */
if (document.querySelector('.challenge-page .sc-challenge')) {
  const challengePanel = document.querySelector('.challenge-page .sc-challenge');
  const challengeLoadMore = challengePanel.querySelector('.result-indicator a');
  const allChallengeBoxes = challengePanel.querySelectorAll('.challenge-block');
  const setProgressBarHtml = () => {
    const showNum = challengePanel.querySelectorAll('.challenge-block:not(hidden)').length;
    challengePanel.querySelector('.result-indicator__text').innerHTML = `Prikazujem ${showNum} od ${allChallengeBoxes.length}`;
    challengePanel.querySelector('.result-indicator__progress-bar').style.width = `${(showNum / allChallengeBoxes.length) * 100}%`;
    challengeLoadMore.hidden = showNum === allChallengeBoxes.length;
  };
  if (challengeLoadMore) {
    challengeLoadMore.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      allChallengeBoxes.forEach((el) => {
        el.removeAttribute('hidden');
      });
      setProgressBarHtml();
    });
    attachEvent('.sc-challenge .infowindow-button a', 'click', () => {
      challengePanel.querySelectorAll('.challenge-block').forEach((el) => {
        el.removeAttribute('hidden');
      });
      setProgressBarHtml();
    });
  }
}
